var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"row align-items-center ml-2"},[_c('i',{staticClass:"fa fa-check mr-2 ml-2 text-success"}),_vm._v(" "),_c('span',{staticClass:"text-secondary"},[_c('b',[_vm._v(_vm._s(_vm.upc))]),_vm._v(" "+_vm._s(_vm.description)+", amount: "+_vm._s(_vm.amount))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }